import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { UseStores } from '../../hooks/UseStores';
import palette from '../../styles/palette';
import * as Sentry from '@sentry/react';
import { scrollToSection } from '../../utils/abdmUtils';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const SelectDropdownMenu = (props) => {
  const { audience } = UseStores();

  const [selected, setSelected] = useState('');
  const [audienceList, setAudienceList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    audience
      .getAudienceCategories()
      .then(() => {
        setAudienceList(audience.audienceCategories);
      })
      .catch((err) => {
        Sentry.captureException(err);
      });
  }, []);

  const selectionChangeHandler = (event) => {
    setSelected(event.target.value);
    audience.setAudience(event.target.value);
    setIsDisabled(false);
  };

  const styles = {
    dropdownInputBox: {
      background: palette.white,
      borderRadius: '4px',
      marginTop: '-1vh',
      width: { xs: '95%', sm: '100%', md: '95%' },
    },
    button: {
      width: { xs: '95%', sm: '100%', md: '95%' },
      marginTop: '4vh',
    },
    link: {
      color: palette.gt_teal_6,
      textDecoration: 'underline',
    },
  };

  return (
    <FormControl fullWidth>
      <Select
        disableUnderline
        labelId="audience-select"
        variant="standard"
        id={props.name}
        name={props.name}
        data-testid="select"
        value={selected}
        onChange={selectionChangeHandler}
        sx={styles.dropdownInputBox}
        displayEmpty
        renderValue={(value) =>
          value ? (
            value
          ) : (
            <em
              style={{ color: palette.gt_text_secondary, fontStyle: 'normal' }}
            >
              Select an audience...
            </em>
          )
        }
      >
        {audienceList?.map((option) => {
          return (
            <MenuItem
              data-testid={`option-item-${option.id}`}
              key={option.id}
              value={option.value}
            >
              {option.value ?? option.label}
            </MenuItem>
          );
        })}
      </Select>
      <Button
        data-testid="confirm-audience"
        disableElevation
        variant="contained"
        color={isDisabled ? 'secondary' : 'primary'}
        size="large"
        endIcon={<ChevronRightIcon />}
        onClick={isDisabled ? null : () => scrollToSection('location')}
        sx={styles.button}
      >
        Confirm audience
      </Button>
      <Link href="#help-section" sx={styles.link} data-testid="need-help">
        {' '}
        Need Help?
      </Link>
    </FormControl>
  );
};

export default observer(SelectDropdownMenu);
